export class DadosReceituario {
    cnes_unidade_saude: string;
    nome_unidade_saude: string;
    unidade_saude_Id: number;
    nome_clinica_medica: string;
    clinica_medica_id: number;
    estado_unidade_saude: string;
    municipio_unidade_saude: string;
    atendimento_id: number;
    presenca_id: number;
    uso_continuo: boolean;
    receitado_em: Date;
    validade_receita: string;
    protocolo: string;
    recomendacao: string;
    observacao: string;
    cns_paciente: string;
    cpf_paciente: string;
    nome_paciente: string;
    logradouro_paciente: string;
    logradouro_numero_paciente: string;
    logradouro_complemento_paciente: string;
    logradouro_bairro_paciente: string;
    logradouro_cidade_paciente: string;
    logradouro_estado_paciente: string;
    sigla_conselho_profissional_emitente: string;
    estado_conselho_profissional_emitente: string;
    numero_conselho_profissional_emitente: number;
    nome_profissional_emitente: string;
    logradouro_profisional_emitente: string;
    logradouro_numero_profissional_emitente: string;
    logradouro_complemento_profissional_emitente: string;
    logradouro_bairro_profissional_emitente: string;
    logradouro_cidade_profissional_emitente: string;
    logradouro_estado_profissional_emitente: string;
    receituario_items: ReceituarioItem[] = [];
  }
  
  export class ReceituarioItem {
    id?;
    criado_em: Date;
    atualizado_em: Date;
    ativo: boolean;
    receituarioV2Id?;
    medicamentoDescricao: string;
    medicamentoId: number;
    quantidadeDispensacao: number;
    posologiaDescricao: string;
    posologiaId: number;
    nomeComercial: string;
    principioAtivo: string;
    concetracao: string;
    formaFarmaceutica: string;
    unidadeFornecimento: string;
    codigoCatMat: string;
    rename: string;
    tipoDose: string;
    observacao: string;
  }
  